"use server";

import { getServerSession } from "next-auth/next";
import { authOptions } from "@/lib/auth";
import { recordMatch, type MatchOutcome } from "@/lib/quoridor-core";

// 클라이언트 컴포넌트(QuoridorGame)에서 게임 종료 시 직접 호출하는 서버 액션.
// 폼 제출이 아니라 일반 함수처럼 호출한다(Next.js가 지원하는 방식). 비로그인이면
// 조용히 아무것도 기록하지 않는다 — 로그인 없이도 계속 플레이만은 가능해야 하므로.
export async function recordMatchResult(
  winner: MatchOutcome,
  firstPlayer: MatchOutcome,
  humanWalls: number,
  aiWalls: number,
) {
  const session = await getServerSession(authOptions);
  const userId = session?.user?.id;
  if (!userId) return;
  await recordMatch(userId, winner, firstPlayer, humanWalls, aiWalls);
}
